module.exports = __webpack_public_path__ + "img/tanker-green.0504a429.svg";